import { useContext } from 'react';
import { Typography } from '@mui/material';
import { useAppDispatch } from 'features';
import { updateDownloadErrorFile } from 'features/Downloads';
import { useFileDownloader } from 'hooks/useFileDownloader';
import { UserSessionContext } from 'providers/UserSessionProvider';
import IntlMessages from 'util/IntlMessages';

import { type SelectedFile } from './interfaces';

interface RetryDownloadProps {
  file: SelectedFile;
}

const RetryDownload: React.FC<RetryDownloadProps> = ({ file }) => {
  const dispatch = useAppDispatch();
  const { downloadFile } = useFileDownloader();

  const { locale } = useContext(UserSessionContext);

  const statusMessages = {
    downloading:
      locale === 'es'
        ? 'Si no inició la descarga de forma automática'
        : 'If the download did not start automatically',
    error: locale === 'es' ? 'Para intentar nuevamente' : 'To try again',
  };

  if (file.status === 'downloaded') return null;

  const message = statusMessages[file.status];

  const handleRetry = () => {
    dispatch(updateDownloadErrorFile(file.id));
    void downloadFile(file);
  };

  return (
    <Typography fontSize={12}>
      {message},{' '}
      <button
        onClick={handleRetry}
        type="button"
        style={{
          background: 'none',
          textDecoration: 'underline',
          border: 'none',
          color: 'inherit',
          cursor: 'pointer',
          fontSize: 12,
          padding: 0,
        }}
      >
        <IntlMessages id="pages.downloader.retry-download-button" />
      </button>
    </Typography>
  );
};

export default RetryDownload;
